import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpDeleteExternalCost, HttpDeleteExternalCostOptions} from '../http/budget.http'

export const useDeleteExternalCost = (options?: UseMutationOptions<void, unknown, HttpDeleteExternalCostOptions>) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (variables: HttpDeleteExternalCostOptions) => httpDeleteExternalCost(variables),
        ...options,
        onSuccess: async (data, variables, context) => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.EXTERNAL_COSTS]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
